import { RbacManager } from './interfaces';
import { RbacItemsHttpAdapter } from './RbacItemsHttpAdapter';
import { RbacLightRuleFactory } from './RbacLightRuleFactory';

const rbacItemsService = new RbacItemsHttpAdapter();
const rbacRuleFactory = new RbacLightRuleFactory();
export const rbacManager = new RbacManager(rbacItemsService, rbacRuleFactory);
